export const cifBd = ["301 181","<g fill='none'><path fill='#006A4E' d='M.5.5h300v180H.5z'/><circle cx='135.5' cy='90.5' r='60' fill='#F42A41'/></g>"]